<template>
<!-- counts as <RouterView /> self-closing component -->
  <div class="h-100 d-block home-top-container">
    <div class="pt-4 h-25 home-header-container text-center">
      <img alt="Vue logo" src="../assets/logo.png">
      <h2 class="p-3">welcome to jeabernathy.com</h2>
    </div>
    <div class="temp-content-container h-75 d-flex justify-content-center align-items-center">
      <h4 class="pb-5">{ <small>UNDER CONSTRUCTION</small> }</h4>
    </div>
  </div>
</template>

<script>
// temp placeholder
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home'
}
</script>
